export default __webpack_public_path__ + "static/media/Android-fr.03c0f607.gif";